import { AutogenLayoutHazardousMaterialsCodesList } from "./autogen/AutogenLayoutHazardousMaterialsCodesList";

export class HazardousMaterialsCodesList extends AutogenLayoutHazardousMaterialsCodesList {

    override onLoad() {
        this.mainDataSource.search();
    }
}
